import { render, staticRenderFns } from "./truck-load-report.html?vue&type=template&id=b4e5f116&scoped=true&"
import script from "./truck-load-report.ts?vue&type=script&lang=js&"
export * from "./truck-load-report.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e5f116",
  null
  
)

export default component.exports